var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRoundPerson2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2594 9.70797C11.1394 9.13464 9.68606 8.66797 7.99939 8.66797C6.31273 8.66797 4.85939 9.13464 3.73939 9.70797C3.4141 9.87551 3.14159 10.1299 2.95213 10.443C2.76266 10.756 2.66364 11.1154 2.66606 11.4813V12.0013C2.66606 12.7346 3.26606 13.3346 3.99939 13.3346H11.9994C12.7327 13.3346 13.3327 12.7346 13.3327 12.0013V11.4813C13.3327 10.7346 12.9261 10.048 12.2594 9.70797ZM6.51939 8.0013H9.47939C10.2861 8.0013 10.9061 7.29464 10.7994 6.49464L10.5861 4.8613C10.3794 3.59464 9.27939 2.66797 7.99939 2.66797C6.71939 2.66797 5.61939 3.59464 5.41273 4.8613L5.19939 6.49464C5.09273 7.29464 5.71273 8.0013 6.51939 8.0013Z",
    fill: "#25262D",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundPerson2);
export default __webpack_public_path__ + "static/media/ic-round-person-2.f602db54e5f51c27f3577143d999578b.svg";
export { ForwardRef as ReactComponent };